import { render, staticRenderFns } from "./UrlParameterForm.vue?vue&type=template&id=e8bba25c"
import script from "./UrlParameterForm.vue?vue&type=script&lang=js"
export * from "./UrlParameterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports